import * as registeredApps from "./register";

export default {
  executeApps() {
    // @ts-ignore
    const apps: RegisteredApp[] = Object.values(registeredApps);
    const executedApps: DisposableApp[] = [];

    console.log(`Initializing FAQ JavaScript... (${apps.length} apps total)`);

    apps.forEach(app => {
      executedApps.push(app());
    });

    return function disposeCallback() {
      executedApps.forEach(disposeApp => {
        if (typeof disposeApp === "function") {
          disposeApp();
        }
      });
    };
  },
};
